import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import * as TechnicianActions from './technician.actions';
import { loadUsers } from '../../../../administration/users/users.actions';
import { selectAllUsers } from '../../../../administration/users/users.selectors';

@Injectable()
export class TechnicianEffects {
  private actions$ = inject(Actions);
  private store = inject(Store);

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TechnicianActions.loadTechnicians),
      switchMap(() => {
        // Dispatch loadUsers to ensure users are loaded
        this.store.dispatch(loadUsers({ params: { size: 100 } }));
        
        // Map users to technicians format
        return this.store.select(selectAllUsers).pipe(
          map(users => {
            const technicians = users
              .filter(u => u.fullName && u.fullName.trim() !== '')
              .map(u => ({
                id: u.id!,
                name: u.fullName!
              }));
            return TechnicianActions.loadTechniciansSuccess({ technicians });
          }),
          catchError((error) =>
            of(
              TechnicianActions.loadTechniciansFailure({
                error: error?.message || 'Failed to load technicians',
              })
            )
          )
        );
      })
    )
  );
}
